'use client';

// npm packages
import React, { useEffect, useState, useRef } from 'react';

// components

// utils
import { cn } from '@/utils/cn';
import { useSelector, useDispatch } from 'react-redux';
import { setIsLogoutPopupShow } from '@/redux/reducers/auth-reducer';
import Icon from '../Icon';
import Text from '../Text';

function LogoutSuccessfulModal({ data, onView, onClose, className }) {
  const modalRef = useRef(null);
  const dispatch = useDispatch();

  const { isLogoutPopupShow } = useSelector((state) => state.auth);

  const [openModal, setOpenModal] = useState(isLogoutPopupShow);

  const handleClose = () => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(false);
      dispatch(setIsLogoutPopupShow(false));
    }, 200);
  };

  useEffect(() => {
    if (isLogoutPopupShow) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [isLogoutPopupShow]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (openModal) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [openModal]);

  useEffect(() => {
    let timer;
    if (openModal) {
      setTimeout(() => {
        handleClose();
      }, 5000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [openModal]);

  return (
    <div
      className={cn(
        'w-full h-full bg-transparent flex !items-end justify-center opacity-0 -z-10 transition-all duration-300 relative',
        openModal && '!opacity-100 !z-[501]',
      )}
    >
      <div
        ref={modalRef}
        className={cn(
          'bg-cape-verde  lg:max-w-[720px] h-[48px] lg:h-[56px] flex items-center justify-between gap-[6px] lg:gap-[16px] mx-8 lg:mx-auto mb-[72px] lg:mb-12 pr-6 pl-16 lg:pr-16 rounded-[4px] transition-all duration-[400ms] shadow-cannot-be-added-modal fixed bottom-0 left-0 right-0',
          className,
        )}
      >
        <Text type="paragraph" className="text-sm font-medium text-white">
          {data}
        </Text>
        <Icon
          type="close"
          color="#fff"
          className="cursor-pointer min-w-[24px]"
          onClick={handleClose}
        />
      </div>
    </div>
  );
}

export default LogoutSuccessfulModal;
